import React, {Component} from 'react';

import axios from 'axios';
import auth0Client from '../Auth';
import {ToastContainer, ToastStore} from 'react-toasts';
import {   withRouter } from "react-router-dom";
//import Claims from '../Claims/Claims';
import {SERVER_URL}  from '../Constants';
import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider, { CSVExport } from 'react-bootstrap-table2-toolkit';
import LostItemFunctions from '../LostItem/LostItemFunctions';


const { ExportCSVButton } = CSVExport;


const lostItemColumns = [
  { dataField: 'itemNumber', sort: true,classes:'text-primary', text: 'Item#', filterable:true,  textAlign: 'left' , headerStyle: (colum, colIndex) => {
    return { width: '50px', textAlign: 'center' };} 
   },
    { dataField: 'ShortDescription', sort: true,classes:'text-primary', text: 'Item', filterable:true,  textAlign: 'left' },
    { dataField: 'itemState', sort: true, formatter: LostItemFunctions.itemStatusDesc, text: 'Status Code', classes:'text-primary', textAlign: 'left'},
    { dataField: 'LongDescription',sort: true, text: 'Description', classes:'text-primary', textAlign: 'left'},
    { dataField: 'foundDate',sort: true, text: 'Age',formatter:LostItemFunctions.formatAge, classes:'text-primary', textAlign: 'left'},
    { dataField: 'storageLocation',sort: true, text: 'Storage', classes:'text-primary', textAlign: 'left'},
    { dataField: 'foundDate',sort: true,formatter: LostItemFunctions.formatDate,classes:'text-primary',  text: 'Found',  headerStyle: (colum, colIndex) => {
      return { width: '120px', textAlign: 'center' };
    }  },
  
    { dataField: 'foundByName',sort: true, text: 'Found By', classes:'text-primary', textAlign: 'left'},
    { dataField: 'isExpensiveItem',sort: true, text: 'Expensive',formatter:LostItemFunctions.formatBoolean, classes:'text-primary', textAlign: 'left'},
    
  ];
  const defaultSorted = [{
    dataField: 'foundDate',
    order: 'asc'
  }];
  
  



  class CurrentInventory extends Component {
    constructor(props) {
      super(props);
        this.state = { lostItems: []}
        this._input = null;
    }
    async componentDidMount() {


        // console.log("Component did load. Auth : " + auth0Client.getIdToken());
         
         this.loadLostItemData();
       
     
       }

       loadLostItemData = () =>{
        try {
          axios.get(`${SERVER_URL}/Reports/CurrentInventory`,{
             headers: { 
               'Authorization': `Bearer ${auth0Client.getIdToken()}`,
               'venueId' : auth0Client.getActiveVenuedId()
             }
           }).then((res)=>{
             
             if (res.status === 401) {
               //place your reentry code
               console.log("Error" + res.status);
              
              }
     
             const lostItems = res.data.recentLostItems;
             var lostItemChartData = [];
             var lostItemPieData = [];
              var totalReturned = 0;
             //var openLostItems = 0;
             if (lostItems){
                //var totalCount = lostItems.length;
                 totalReturned= lostItems.filter(l => l.itemState === 'R').length;
                // openLostItems= lostItems.filter(l => l.itemState === 'Q').length;

             };

             this.setState({
                lostItemSummaryData : lostItemChartData,
                lostItemPieData : lostItemPieData,
                numReturned : totalReturned,
                lostItems : lostItems,
              });


            });
        }catch(e){

        }
    }


    renderToast=()=>{
        return <div>
            
            <ToastContainer position={ToastContainer.POSITION.TOP_RIGHT} lightBackground store={ToastStore}/>
        </div>
      }

      print=()=>{
       
            // STEP 1: Create a new window, a div, and append it to the window. The div 
            // *MUST** be created by the window it is to be appended to (Edge only)
          

            this.externalWindow = window.open('', '', 'width=600,height=400,left=200,top=250');
            var ss = document.createElement("link"); ss.type = "text/css"; ss.rel = "stylesheet"; ss.href = "https://bootswatch.com/4/lux/bootstrap.min.css"; 
            this.externalWindow.document.getElementsByTagName("head")[0].appendChild(ss);


            this.containerEl = this.externalWindow.document.createElement('div');
            this.externalWindow.document.body.appendChild(this._input);
        
      }
      renderLostItemGrid=()=>{
        return (
    
          <div >
           
           
           {this.renderToast()}
           {this.state.lostItems === null && <p>Loading lostItems...</p>}
            <ToolkitProvider 
            bootstrap4
              keyField='id' 
              data={ this.state.lostItems } 
              columns={ lostItemColumns } 
              exportCSV
              defaultSorted={defaultSorted}
             
              >
              {
        props => (
          <div>
        
           <ExportCSVButton { ...props.csvProps }>Export CSV for Printing</ExportCSVButton>
           
        <hr />
            <BootstrapTable
            
              striped
                condensed
             
              
              { ...props.baseProps }
             
            />
          </div>
        )
      }</ToolkitProvider>
    
          </div>
    
    
        )
    
        
      }
    

    render(){

        return(

            <div className="text-center" ref={c => (this._input = c)}> <h5> Current Inventory Report </h5>
            <h6>{LostItemFunctions.formatDate(Date())}</h6>
              {this.renderToast()}
              {this.renderLostItemGrid()}
            
            </div>

        )



    }
}


export default withRouter(CurrentInventory);